import styled from 'styled-components';
import CctvIconSvg from '../../assets/hotels/amenities/cctv.svg';

const CctvIcon = styled(CctvIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CctvIcon;
